import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { IInfoCard } from 'src/app/models/api/integration.model';
import { MenuAction } from 'src/app/models/menuAction.model';

@Component({
  selector: 'app-data-card',
  templateUrl: './data-card.component.html',
  styleUrls: ['./data-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataCardComponent {
  @Input() card!: IInfoCard;
  @Output() cardOnClick = new EventEmitter<{ card: IInfoCard; action: MenuAction }>();

  constructor(private readonly _router: Router) {}

  public actionOnClick(action: MenuAction): void {
    this.cardOnClick.emit({ card: this.card, action: action });

    // If the action should open the dialog (edit), update query params so parent can react
    if (action.shouldOpenDialog) {
      this._router.navigate([], {
        queryParams: this.card.internalNavigation.query,
        queryParamsHandling: 'merge',
      });
    }
  }
}
